import React from 'react';
import PropTypes from 'prop-types';
import CustomJS from './CustomJS';

// NOSONAR: `category`/`button` are Blockly toolbox-XML pseudo-elements (rendered via
// react-blockly-toolbox, then serialized to Blockly's toolbox XML), not real DOM/React
// elements, so `iconclass`, `text`, and `callbackKey` are valid Blockly toolbox attributes
// rather than unknown props. See the same pattern in Toolbox.js, Search/index.js, and
// MyBlocks/index.js.
export default function JSBlocks(props){
    return (
        <category name='Code Blocks' id='JSVariables' iconclass='category with-icon-paths snap-icon-code_block_dual'> {/* NOSONAR */}
            <button text="Create Custom JS Code Block" callbackKey="createCustomJSBlock"></button> {/* NOSONAR */}
            <CustomJS context={props.context} openJSEditor={props.openJSEditor}/>
        </category>
    );
}

JSBlocks.propTypes = {
    context: PropTypes.object,
    openJSEditor: PropTypes.func
};
